/**
 * Created by Carsten Bühler
 * User: CBuehler on 29.09.2015
 * Copyright: xdot GmbH 2015
 */
import { LiferayClient } from '@convotis/liferay-client/lib/client';
import { FileUploader } from '@convotis/liferay-client/lib/upload';

const DEBUG = process.env.NODE_ENV !== 'production';

/**
 *
 * Custom @convotis/liferay-client extended for the Liferay-Widget-React-Framework (Lwr-Framework).
 *
 */
class LwrLiferayClient extends LiferayClient {
    invokeWithContext(method, data, context){

        if (DEBUG) {
            if (data) {
                Object.keys(data).forEach(p => {
                    if (typeof data[p] === 'undefined') {
                        console.warn('Undefined param: ' + p);
                    }
                });
            }
        }

        let v = {
            'serviceContext': {
                'scopeGroupId': lrClient.getScopeGroupId(),
                'attributes': context
            }
        };
        if (arguments.length > 2 && typeof (context) !== 'undefined') {
            v.serviceContext.attributes = context;

            v = {
                ...v,
                ...data
            };
        } else {
            v.serviceContext.attributes = data;
        }
        return this.invoke(method, v);
    }

    getScopeGroupId(){
        return Liferay.ThemeDisplay.getScopeGroupId();
    }

    invokeExternal({ baseUrl, path, params = {}, headers = {}, }){
        return new Promise((resolve, reject) => {
            const invokePath = `${baseUrl}/api/jsonws/invoke`;
            const reqData = `cmd=${JSON.stringify({ [path]: params })}`;
            fetch(invokePath, {
                method: 'POST',
                body: reqData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    ...headers,
                },
            })
                .then(response => {
                    if (response.ok) {
                        resolve(response.json());
                    } else {
                        reject(response.text());
                    }
                })
        })
    }
}

const lrClient = new LwrLiferayClient({
    mobileApps: {
        defaultAutoInstall: false,
        defaultAutoInstallPush: false
    },
    useBasicAuth: false,
    url: window.location.protocol + '//' + window.location.host
});

export {
    lrClient as Client,
    FileUploader
};



// WEBPACK FOOTER //
// ./js/lwr-client.js